import { Component, Input } from '@angular/core';
import { ICON_TYPE, NavigationNode } from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';

@Component({
  selector: 'app-custom-navigation-ui',
  standalone: false,
  templateUrl: './custom-navigation-ui.component.html',
  styleUrls: ['./custom-navigation-ui.component.scss'],
})
export class CustomNavigationUiComponent {
  iconType = ICON_TYPE;

  /**
   * The navigation node to render.
   */
  @Input() node!: NavigationNode | null;

  constructor(protected userAccountFacade: UserAccountFacade) {}

  isNavOpen = false;
  toggleNav() {
    this.isNavOpen = !this.isNavOpen;
  }

  
  openNav() {
    this.isNavOpen = true;
  }

  closeNav() {
    this.isNavOpen = false;
  }
}
